// https://medium.com/@mntlmaxi/make-your-vue-app-last-with-indexeddb-66f02708830e
// https://www.npmjs.com/package/idb#changes

import { openDB } from 'idb'
const dbPromise = _ => {
  if (!('indexedDB' in window)) {
    throw new Error('Browser does not support IndexedDB')
  }

  return openDB('EverydayDB', 12, {
    upgrade (db, oldVersion, newVersion, transaction) {
      if (!db.objectStoreNames.contains('user')) {
        const store = db.createObjectStore('user', {
          keyPath: 'key'
        })
        store.createIndex('key', 'key')
      }

      if (!db.objectStoreNames.contains('updateDate')) {
        const store = db.createObjectStore('updateDate', {
          keyPath: 'key'
        })
        store.createIndex('key', 'key')
      }

      if (!db.objectStoreNames.contains('updateDateLocal')) {
        const store = db.createObjectStore('updateDateLocal', {
          keyPath: 'key'
        })
        store.createIndex('key', 'key')
      }

      if (!db.objectStoreNames.contains('activities')) {
        const store = db.createObjectStore('activities', {
          keyPath: 'id'
        })
        store.createIndex('id', 'id')
      }

      if (!db.objectStoreNames.contains('trackActivities')) {
        const store = db.createObjectStore('trackActivities', {
          keyPath: 'date'
        })
        store.createIndex('date', 'date')
      }
    }
  })
}

const saveToStorage = async (storeName, tasks) => {
  try {
    const db = await dbPromise()
    await db.put(storeName, tasks)
  } catch (error) {
    console.log(error)
    return error
  }
}

const deleteItem = async (storeName, key) => {
  const db = await dbPromise()
  const tx = db.transaction(storeName, 'readwrite')
  const store = tx.objectStore(storeName)
  return store.delete(key)
}

const checkStorage = async storeName => {
  try {
    const db = await dbPromise()
    const tx = db.transaction(storeName, 'readonly')
    const store = tx.objectStore(storeName)
    return store.getAll()
  } catch (error) {
    console.log(error)
    return error
  }
}

const getItem = async (storeName, indexName, key) => {
  try {
    const db = await dbPromise()
    const value = await db.getFromIndex(storeName, indexName, key)
    return value
  } catch (error) {
    console.log(error)
  }
}

export default {
  checkStorage,
  saveToStorage,
  getItem,
  deleteItem
}



// WEBPACK FOOTER //
// ./src/data/indexedDBService.js